import {Stack} from "@mui/material";
import type {RegExResolver} from "../../../../../../sdo/Resolver.ts";
import {MatchModeRow, F, SummaryPill, SummaryPillRow, rowSx, set, type ResolverEditorProps} from "./ResolverUtils.tsx";

function RegExEditor({draft, editing, onChange}: ResolverEditorProps & { draft: RegExResolver }) {
    if (!editing) {
        return (
            <SummaryPillRow>
                <SummaryPill label="Pattern" value={draft.pattern}/>
            </SummaryPillRow>
        );
    }

    const upd = (key: string, value: unknown) => set(draft, key, value, onChange);
    return (
        <Stack direction="column" spacing={1} alignItems="center">
            <MatchModeRow draft={draft} editing={editing} onChange={onChange}/>
            <Stack direction="row" sx={rowSx}>
                <F value={draft.pattern} placeholder="Regular Expression" onChange={(v) => upd("pattern", v)} width="400px"/>
            </Stack>
        </Stack>
    );
}

export default RegExEditor;
